import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
interface DeleteSettingParams {
  settingId: string;
  clubSlug: string;
}
export const useDeleteSetting = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: (_, t1) => {
        const {
          clubSlug: clubSlug_0
        } = t1;
        queryClient.invalidateQueries({
          queryKey: ["settings", clubSlug_0],
          refetchType: "all"
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
async function _temp(t0) {
  const {
    settingId,
    clubSlug
  } = t0;
  const response = await fetch(`/api/club-settings/${settingId}?clubSlug=${clubSlug}`, {
    method: "DELETE"
  });
  if (!response.ok) {
    throw new Error("Failed to delete setting");
  }
  return response.json();
}